import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'eliminarExamenFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'delete_agenda', 
									tablaPost: ['info_agendas']
								 }
							 }) 
						break;
						case 'garantiaExamenFtn':
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_garantia', 
									tablaPost: ['datos_pacientes','info_garantia','garantia_antecedentes','garantia_diagnosticos','garantia_pruebas']
								 }
							 }) 							 
						break;
					}
				}
				
				await this.save(event.save)						

				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'garantiaExamenFtn':					
    						await this.spliceDataGet(this.indexData)
						break;
						case 'eliminarExamenFtn':					
    						await this.spliceDataGet(this.indexData)
						break;
					}
				}	

				await this.resetGlobal({state: 'indexData'}) 
				await this.resetGlobal({state: 'openModal'}) 
				await this.resetDataForm()
				
				return true
			}
			catch{

			}			
		}		
	},
}
